export default __webpack_public_path__ + "static/media/PR_anymedi 2.6f68791d.png";